'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = function (children) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var context, DrupalPageContextProvider, drupalContextProvider;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        context = {
                            state: {
                                drupalPage: null,
                                entities: []
                            }
                        };

                        DrupalPageContextProvider = function (_React$Component) {
                            (0, _inherits3.default)(DrupalPageContextProvider, _React$Component);

                            function DrupalPageContextProvider() {
                                (0, _classCallCheck3.default)(this, DrupalPageContextProvider);
                                return (0, _possibleConstructorReturn3.default)(this, (DrupalPageContextProvider.__proto__ || (0, _getPrototypeOf2.default)(DrupalPageContextProvider)).apply(this, arguments));
                            }

                            (0, _createClass3.default)(DrupalPageContextProvider, [{
                                key: 'getChildContext',
                                value: function getChildContext() {
                                    return { hnContext: context };
                                }
                            }, {
                                key: 'render',
                                value: function render() {
                                    return React.Children.only(this.props.children);
                                }
                            }]);
                            return DrupalPageContextProvider;
                        }(React.Component);

                        DrupalPageContextProvider.childContextTypes = {
                            hnContext: PropTypes.object
                        };
                        drupalContextProvider = React.createElement(DrupalPageContextProvider, null, children);
                        _context.next = 6;
                        return asyncBootstrapper(drupalContextProvider, {
                            componentWillUnmount: true
                        });

                    case 6:
                        return _context.abrupt('return', drupalContextProvider);

                    case 7:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));
};

var _propTypes = require('prop-types');

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = require('react');

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = _promise2.default))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var asyncBootstrapper = require('react-async-bootstrapper'); // tslint:disable-line:no-var-requires
//# sourceMappingURL=waitForHnData.js.map
